<script lang="ts" setup>
type Props = {
  selected?: boolean
}
defineProps<Props>()
</script>

<template>
  <button
    :class="{
      'bg-[rgba(252,207,207,1)]': !selected,
      'bg-[rgba(0,147,216,1)] text-[rgba(255,255,255,1)]': selected,
    }"
  >
    <slot />
  </button>
</template>
